/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoShow/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2CalendarNoShowIcon from 'DesignSystem/Svgs/Tysiav2CalendarNoShowIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NoShow({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/StateIcon/NoShow"
  
}) {
let dtColorsRed500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.500'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="NoShow.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z2jk0Sz': dtColorsRed500,'--pl-2-Z2jk0Sz': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-3-Z2jk0Sz': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-4-Z2jk0Sz': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-5-Z2jk0Sz': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2CalendarNoShowIcon
  viewPath={`${viewPath}/Tysiav2CalendarNoShowIcon`}
 fill2={dtColorsWhite}
 height={dtSpaceXs}
/>
</div>
{children}
</React.Fragment>)
}